<app-loader></app-loader>
<!-- ✅ Desktop & Large Screens  -->
<div class="hidden md:flex flex-col">
  <div class="flex justify-end header p-6">
    <!-- <h1>Redeem</h1> -->
    <div class="flex mr-auto">
      <button (click)="openRulesModal()" class="flex btn-primary">
        Redeem Rules
      </button>
    </div>
    <div class="flex ml-auto">
      <span
        class="view-toggle-btn hidden md:block mr-4 mt-2 cursor-pointer"
        (click)="toggleView()"
        title="Toggle View"
      >
        <i
          class="fa text-2xl"
          [ngClass]="viewMode === 'grid' ? 'fa-th-large' : 'fa-list-ul'"
        ></i>
      </span>

      <button (click)="openModal()" class="flex btn-primary">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>

        Redeem Request
      </button>
    </div>
  </div>

  <div class="mb-8 lg:mt-[10px] px-6 flex flex-col">
    <!-- Dropdown for all screens -->
    <div
      class="reset-btn h-12 flex flex-col sm:flex-row items-center justify-end"
    >
      <div
        class="flex sm:flex-row items-center space-y-1 sm:space-y-0 sm:space-x-3 transition-opacity duration-300 ease-in-out"
        [class.opacity-0]="!showDateFilter"
        [class.pointer-events-none]="!showDateFilter"
      >
        <div
          class="relative flex items-center border border-[#2ee4e8] rounded-tl-lg rounded-bl-lg overflow-hidden cursor-pointer w-full sm:w-auto"
        >
          <input
            type="date"
            [(ngModel)]="startDate"
            (ngModelChange)="onStartDateChange($event)"
            class="text-[#2ee4e8] bg-transparent focus:ring-[#2ee4e8] focus:border-[#2ee4e8] py-1 pl-6 pr-2 outline-none cursor-pointer"
          />
        </div>

        <div
          class="relative flex items-center border border-[#2ee4e8] rounded-none overflow-hidden cursor-pointer w-full sm:w-auto"
        >
          <input
            type="date"
            [(ngModel)]="endDate"
            [min]="startDate || null"
            class="text-[#2ee4e8] bg-transparent focus:ring-[#2ee4e8] focus:border-[#2ee4e8] py-1 pl-6 pr-2 outline-none cursor-pointer"
          />
        </div>

        <button
          (click)="resetDates()"
          class="sm:w-auto border border-[#2ee4e8] text-[#2ee4e8] hover:bg-[#2ee4e8] hover:text-white rounded-tr-lg rounded-br-lg py-1 px-5"
        >
          Reset
        </button>
      </div>
    </div>
    <div
      class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-2 w-full"
    >
      <div class="flex items-center gap-4 w-full mt-2 sm:w-auto">
        <!-- Dropdown -->
        <div
          class="relative inline-block text-left w-full sm:w-48 md:w-56 lg:w-[10rem]"
        >
          <div class="flex w-full">
            <button
              type="button"
              class="bg-transparent border border-[#2ee4e8] text-[#2ee4e8] text-sm px-3 py-2 rounded-tl-lg rounded-bl-lg"
              (click)="dropdownOpen = !dropdownOpen"
            >
              ▼
            </button>
            <button
              type="button"
              class="bg-transparent text-white text-left border border-[#2ee4e8] text-sm px-4 py-2 w-full rounded-none"
              (click)="dropdownOpen = !dropdownOpen"
            >
              {{ activeTab }}
            </button>
          </div>

          <ul
            *ngIf="dropdownOpen"
            class="absolute mt-1 bg-gray-800 text-white border border-[#2ee4e8] shadow-lg rounded-md w-full z-10"
          >
            <li *ngFor="let tab of tabs">
              <a
                href="#"
                class="block px-4 py-2 hover:bg-cyan-600 cursor-pointer capitalize"
                (click)="selectFilter(tab, $event)"
              >
                {{ tab }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Right side (Search) -->
      <div class="flex sm:flex-row items-center gap-2 w-full lg:w-[30rem]">
        <span (click)="showDateFilter = !showDateFilter" class="cursor-pointer">
          <img
            src="https://cmax.pages.dev/assets/icons/date.png"
            alt="Calendar-icon"
          />
        </span>
        <div class="relative flex-1">
          <input
            type="text"
            placeholder="Search..."
            [(ngModel)]="searchTerm"
            class="w-full bg-transparent text-white border border-[#2ee4e8] text-sm rounded-tl-lg rounded-bl-lg rounded-tr-none rounded-br-none py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-cyan-400"
          />
          <svg
            class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <button
          (click)="GetAllGames(true)"
          class="text-black px-4 py-2 rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none font-semibold [background:linear-gradient(0deg,#19E4E0_0%,#0E7E7C_100%)]"
        >
          Search
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Mobile & Small Screens -->
<div class="md:hidden flex flex-col gap-3 p-4">
  <!-- Date Filters (hidden until toggled) -->
  <div
    *ngIf="showMobileDateFilter"
    class="flex flex-col sm:flex-row items-center gap-2 animate-fadeIn"
  >
    <div class="flex flex-row gap-2 w-full">
      <input
        type="date"
        [(ngModel)]="startDate"
        (ngModelChange)="onStartDateChange($event)"
        class="w-full border border-[#2ee4e8] text-[#2ee4e8] bg-transparent rounded-tr-none rounded-br-none rounded-tl-lg rounded-bl-lg py-2 px-3 outline-none"
      />

      <input
        type="date"
        [(ngModel)]="endDate"
        [min]="startDate || null"
        (ngModelChange)="GetAllGames(true)"
        class="w-full border border-[#2ee4e8] text-[#2ee4e8] bg-transparent rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none py-2 px-3 outline-none"
      />
    </div>
    <button
      (click)="resetDates()"
      class="w-full border border-[#2ee4e8] text-[#2ee4e8] hover:[background:linear-gradient(0deg,#19E4E0_0%,#0E7E7C_100%)] hover:text-black rounded-lg py-2"
    >
      Reset
    </button>
  </div>

  <!-- 2️⃣ Search Bar Row -->
  <div class="flex items-center gap-2">
    <span
      (click)="showMobileDateFilter = !showMobileDateFilter"
      class="cursor-pointer"
    >
      <img
        src="https://cmax.pages.dev/assets/icons/date.png"
        alt="Calendar-icon"
        class="w-6 h-6"
      />
    </span>
    <div class="relative flex-1">
      <input
        type="text"
        placeholder="Search..."
        [(ngModel)]="searchTerm"
        class="w-full bg-transparent text-white border border-[#2ee4e8] rounded-tl-lg rounded-bl-lg rounded-tr-none rounded-br-none py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-cyan-400"
      />
      <svg
        class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        />
      </svg>
    </div>
    <button
      (click)="GetAllGames(true)"
      class="text-black px-4 py-2.5 rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none font-semibold [background:linear-gradient(0deg,#19E4E0_0%,#0E7E7C_100%)]"
    >
      Search
    </button>
  </div>

  <!-- 3️⃣ Redeem Dropdown + Button Row -->
  <div class="flex items-center gap-2 w-full mt-1">
    <!-- Dropdown -->
    <div class="relative inline-block text-left w-[50%]">
      <div class="flex w-full">
        <button
          type="button"
          class="bg-transparent border border-[#2ee4e8] text-[#2ee4e8] text-sm px-3 py-2 rounded-tl-lg rounded-bl-lg"
          (click)="dropdownOpen = !dropdownOpen"
        >
          ▼
        </button>
        <button
          type="button"
          class="bg-transparent text-white text-left border border-[#2ee4e8] text-sm px-4 py-2 w-full rounded-none"
          (click)="dropdownOpen = !dropdownOpen"
        >
          {{ activeTab }}
        </button>
      </div>

      <ul
        *ngIf="dropdownOpen"
        class="absolute mt-1 bg-gray-800 text-white border border-[#2ee4e8] shadow-lg rounded-md w-full z-10"
      >
        <li *ngFor="let tab of tabs">
          <a
            href="#"
            class="block px-4 py-2 hover:bg-cyan-600 cursor-pointer capitalize"
            (click)="selectFilter(tab, $event)"
          >
            {{ tab }}
          </a>
        </li>
      </ul>
    </div>

    <!-- Redeem Button -->
    <button
      (click)="openModal()"
      class="flex items-center justify-center gap-1 w-[50%] px-2 py-2 border-none rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none font-semibold text-black [background:linear-gradient(0deg,#19E4E0_0%,#0E7E7C_100%)]"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 4.5v15m7.5-7.5h-15"
        />
      </svg>
      <span>Redeem Request</span>
    </button>
  </div>
</div>

<div class="rounded-xl p-4 md:block hidden -mt-[5rem] header-box">
  <!-- Header box -->
  <div class="flex justify-center -mb-[14px]">
    <div class="relative inline-block">
      <!-- Background Image -->
      <img
        src="Edge.png"
        alt="History Background"
        class="w-full max-w-md mx-auto h-auto rounded-t-xl"
      />

      <!-- Text Overlay -->
      <div
        class="absolute inset-0 flex items-center justify-center text-white font-bold text-lg"
      >
        History
      </div>
    </div>
  </div>

  <div class="flex flex-col w-full mt-2">
    <!-- Table header -->
    <div
      class="grid text-gray-400 text-sm mb-2 bg-[#13192e] px-1 py-1.5 rounded-md border-b-2 border-[#a6b1c2]"
    ></div>
  </div>
</div>
<div *ngIf="viewMode == 'grid'">
  <!-- Wrapper Grid -->
  <div
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-16 pb-10 md:pb-0 my-20"
    (scroll)="onGridViewScroll()"
    #gamesGrid
    *ngIf="filteredGames.length > 0; else noRecord"
  >
    <!-- Card -->
    <!-- Card -->
    <div
      *ngFor="let game of filteredGames"
      class="relative bg-[#13192e] text-white rounded-2xl shadow-lg w-[90%] mx-auto"
    >
      <!-- Image + Name + Payment Method -->
      <div class="flex items-center absolute -top-11 left-6">
        <div
          class="w-24 h-24 rounded-2xl overflow-hidden shadow-md border-2 border-[#7de7e5]"
        >
          <img
            [src]="getGameImage(game.Name)"
            alt="{{ game.Name }}"
            class="w-full h-full object-cover"
          />
        </div>
        <div class="ml-4">
          <h3 class="font-bold text-xl">{{ game.Name }}</h3>
          <small class="block mt-4 text-lg">{{ game?.PaymentMethod }}</small>
        </div>
      </div>

      <!-- Amount (Top Right Corner) -->
      <p
        class="absolute top-4 right-4 font-bold text-lg"
        [ngClass]="{
          'text-green-400': game.StatusDescription === 'Approved',
          'text-yellow-400': game.StatusDescription === 'Pending',
          'text-red-400': game.StatusDescription === 'Declined'
        }"
      >
        ${{ game.NetPaidAmount }}
      </p>

      <!-- Card Body -->
      <div class="pt-12 px-4 pb-16">
        <div class="mt-4 flex text-sm font-bold text-center">
          <p class="w-1/4">Score</p>
          <p class="w-1/4">Reg No:</p>
          <p class="w-1/2">Date & Time</p>
        </div>
        <div class="flex text-sm mt-4 text-center">
          <p class="w-1/4">{{ game.RequestAmount }}</p>
          <p class="w-1/4">{{ game.Id }}</p>
          <p class="w-1/2">
            {{ game.AddedDate | date : "d MMM, y • h:mm a" }}
          </p>
        </div>
      </div>

      <!-- Status Button -->
      <div class="absolute bottom-0 left-0 right-0">
        <button
          class="w-full h-12 font-semibold rounded-b-2xl relative flex items-center justify-center"
          [ngClass]="{
            'bg-green-600': game.StatusDescription === 'Approved',
            'bg-yellow-600': game.StatusDescription === 'Pending',
            'bg-red-600': game.StatusDescription === 'Declined'
          }"
        >
          <!-- Centered text -->
          <span>{{ game.StatusDescription }}</span>
          <!-- Pending: Retry button (placed to the right) -->
          <button
            *ngIf="game.StatusDescription === 'Pending'"
            type="button"
            (click)="onRetry(game)"
            class="absolute right-4 px-3 py-1 --button text-sm font-semibold rounded hover:opacity-90"
          >
            Retry
          </button>
          <!-- Declined info icon -->
          <div
            class="absolute right-4"
            *ngIf="game.StatusDescription === 'Declined'"
          >
            <fa-icon
              [icon]="infoIcon"
              class="hover-icon cursor-pointer"
            ></fa-icon>
            <div
              class="tooltip absolute bottom-full mb-2 left-1/2 transform -translate-x-1/2"
            >
              Reason: {{ game.StatusReason }}
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="min-w-full mb-12" *ngIf="viewMode == 'table'">
  <div class="grid grid-cols-10 text-gray-400 text-sm mb-4 max-w-[98%] ml-4">
    <div>Sr No.</div>
    <div>Req No:</div>
    <div>Game</div>
    <div>Amount</div>
    <div>Status</div>
    <div>Account Info</div>
    <div>Account Type</div>
    <div>Payment Method</div>
    <div>Reason</div>
    <div>Date And Time</div>
  </div>

  <div
    (scroll)="onTableViewScroll()"
    #gamesTable
    class="space-y-2 h-[45dvh] overflow-y-scroll max-w-[98%] mx-auto show-scrollbar"
    *ngIf="filteredGames.length > 0; else noRecord"
  >
    <div
      *ngFor="let game of filteredGames; let i = index"
      class="grid grid-cols-10 items-center px-4 py-3 bg-[#3b3e4c] rounded-md mr-1"
    >
      <div class="text-gray-300">{{ i + 1 }}</div>
      <div class="text-gray-300">{{ game.Id }}</div>
      <div class="text-gray-300">{{ game.Name }}</div>
      <div class="text-white flex items-center gap-2">
        {{ game.RequestAmount }}
      </div>
      <div class="text-white flex items-center gap-2">
        {{ game.StatusDescription }}
      </div>

      <div class="text-gray-400 text-sm gap-2">
        {{ game.AccountInfo }}
      </div>
      <div class="text-gray-400 text-sm">
        {{ game.AccountType }}
      </div>
      <div class="text-gray-400 text-sm">
        {{ game.PaymentMethod }}
      </div>

      <div class="text-white flex items-center gap-2">
        {{ game.StatusReason | slice : 0 : 15 }}
      </div>
      <div class="text-gray-400 text-sm">
        {{ game.AddedDate | date : "MMM d, y, h:mm a" }}
      </div>
    </div>
  </div>
</div>
<ng-template #noRecord>
  <div class="no-records-found">
    <p class="text-center">No records found.</p>
  </div>
</ng-template>
<!-- for pending -->
<div *ngIf="showModal" (click)="closeModal()">
  <app-add-redeem
    [isFromRedeem]="true"
    [showModal]="showModal"
    (closeModal)="closeModal()"
    [selectedGame]="selectedGame"
    [requestId]="requestId"
    (isModalOpen)="showModal = $event"
  ></app-add-redeem>
</div>

<!-- Modal for Redeem Rules -->
<div
  *ngIf="showRulesModal"
  class="fixed inset-0 bg-black/80 flex items-center justify-center modal-overlay z-999"
  (click)="closeRulesModal()"
>
  <div
    class="bg-[var(--background)] rounded-xl w-full max-w-md shadow-lg modal slide-up z-999 max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <!-- Header -->
    <div
      class="flex items-center justify-between px-6 py-4 border-b border-gray-400"
    >
      <h2 class="text-lg font-semibold text-white">Redeem Rules</h2>
      <button
        (click)="closeRulesModal()"
        class="text-gray-400 hover:text-white transition-colors"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="px-6 py-4 overflow-y-auto flex-1">
      <div class="space-y-4">
        <div *ngFor="let rule of redeemRules; let i = index" class="flex gap-3">
          <div
            class="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-cyan-400 to-teal-600 flex items-center justify-center text-white text-sm font-semibold"
          >
            {{ i + 1 }}
          </div>
          <div class="flex-1">
            <h3 class="text-white font-medium mb-1">{{ rule.title }}</h3>
            <p class="text-gray-400 text-sm">{{ rule.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="px-6 py-4 border-t border-gray-400">
      <button (click)="closeRulesModal()" class="w-full btn-primary">
        I Understand
      </button>
    </div>
  </div>
</div>
